import React, { useEffect, useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { connect } from 'react-redux';
import { showFilteredSystemGroups, showFilteredSystemGroupsNames, updateFilteredSystemGroupsNames } from '../../stores/actions/dashboardActions';
import { useRef } from 'react';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

interface SystemGroupSearchBarProps {
	systemGroups: any[];
	dashboardFilteredSystemGroups: number[];
	dashboardFilteredSystemGroupsNames: string[];
	isSystemGroupSearchBarVisible: boolean;
    isFilteredSystemGroupNameUpdated: boolean;
	showFilteredSystemGroups: (filteredSystemGroups: number[]) => void;
	showFilteredSystemGroupsNames: (filteredSystemGroupsNames: string[]) => void;
	updateFilteredSystemGroupsNames: (isUpdatedName: boolean) => void;
}

const SystemGroupSearchBar = ({
	systemGroups,
	dashboardFilteredSystemGroupsNames,
	dashboardFilteredSystemGroups,
	isSystemGroupSearchBarVisible,
    isFilteredSystemGroupNameUpdated,
	showFilteredSystemGroups,
	showFilteredSystemGroupsNames,
	updateFilteredSystemGroupsNames,
}: SystemGroupSearchBarProps) => {
    const systemGroupNames = [...systemGroups].map((systemGroup) => systemGroup.name);
    const systemGroupOptions = systemGroupNames.sort();
    const ref = useRef();

	useEffect(() => {
		if (isFilteredSystemGroupNameUpdated && dashboardFilteredSystemGroups?.length) {
			const currentPickedSystemGroups: any[] = [];
			dashboardFilteredSystemGroups.forEach((filteredSystemGroupId) => {
				const currentSystemGroupReference = systemGroups.find(({ ID }) => ID === filteredSystemGroupId);
				if (currentSystemGroupReference) {
					currentPickedSystemGroups.push(currentSystemGroupReference);
				}
			});
			const currentPickedSystemGroupsNames: string[] = currentPickedSystemGroups.map((systemGroup) => systemGroup.name);
			showFilteredSystemGroupsNames(currentPickedSystemGroupsNames);
            updateFilteredSystemGroupsNames(false);
		}
	}, [isFilteredSystemGroupNameUpdated, dashboardFilteredSystemGroupsNames, dashboardFilteredSystemGroups, showFilteredSystemGroupsNames, systemGroups, updateFilteredSystemGroupsNames]);

    useEffect(() => {
		updateFilteredSystemGroupsNames(true);
	}, [updateFilteredSystemGroupsNames, systemGroups.length]);

	useEffect(() => {
		ref.current.focus();
	}, [isSystemGroupSearchBarVisible]);


	const handleSelectChange = (e, pickedSystemGroupsNames) => {
		showFilteredSystemGroupsNames(pickedSystemGroupsNames);
		const pickedSystemGroupsIds: number[] = [];
		pickedSystemGroupsNames.forEach((pickedSystemGroupName: string) => {
			const [currentSystemGroup] = systemGroups
				// return systemGroup id using systemGroup name:
				.map((systemGroup) => {
					if (systemGroup.name === pickedSystemGroupName) {
						return systemGroup.ID;
					}
					return null;
				})
				// remove undefined values:
				.filter((value) => value !== null);
			if (currentSystemGroup) {
				pickedSystemGroupsIds.push(currentSystemGroup);
			}
		});
		showFilteredSystemGroups(pickedSystemGroupsIds);
	};
	const [inputValue, setInputValue] = useState("");
    return (
		<Autocomplete
			multiple
			id='checkboxes-systemGroups'
			options={systemGroupOptions}
			value={dashboardFilteredSystemGroupsNames || []}
			inputValue={inputValue}
			disableCloseOnSelect
			getOptionLabel={(systemGroup) => systemGroup}
			renderOption={(systemGroup, { selected }) => (
				<>
					<Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8, color: 'gray' }} checked={selected} />
					{systemGroup}
				</>
			)}
			style={{
				backgroundColor: 'rgba(250,250,250,0.75)',
				transition: '0.3s',
				margin: isSystemGroupSearchBarVisible ? '0 15px 15px 15px' : '0 15px',
				height: isSystemGroupSearchBarVisible ? 'auto' : '0',
				opacity: isSystemGroupSearchBarVisible ? '1' : '0',
			}}
			renderInput={(systemGroups) =>
				<TextField
					{...systemGroups}
					variant='outlined'
					label='System Groups search bar'
					placeholder=''
					inputRef={ref}
					onChange={(e) => setInputValue(e.target.value)}
				/>
			}
			onChange={(e, pickedSystemGroups) => handleSelectChange(e, pickedSystemGroups)}
			fullWidth
			disabled={!isSystemGroupSearchBarVisible}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		systemGroups: state.dashboard.systemGroups,
		dashboardFilteredSystemGroups: state.dashboard.dashboardFilteredSystemGroups,
		dashboardFilteredSystemGroupsNames: state.dashboard.dashboardFilteredSystemGroupsNames,
		isFilteredSystemGroupNameUpdated: state.dashboard.isFilteredSystemGroupNameUpdated,
		isSystemGroupSearchBarVisible: state.dashboard.isSystemGroupSearchBarVisible,
	};
};

const actions = {
	showFilteredSystemGroups,
	showFilteredSystemGroupsNames,
	updateFilteredSystemGroupsNames,
};

export default connect(mapStateToProps, actions)(SystemGroupSearchBar);
